import { gql } from './apollo';

export const SEARCH_TOKEN = gql`
    query (
        $email: MultiTypeInput!
        $name: MultiTypeInput!
        $recipient: MultiTypeInput!
        $order: MultiTypeInput!
        $limit: Int!
        $offset: Int!
    ) {
        table(
            name: "trnsx_ecom_activegc"
            filter: [
                {
                    or_: [
                        { left: "company_name", right: $name, expression: "iLIKE" }
                        { left: "customer_email", right: $email, expression: "iLIKE" }
                        { left: "customer", right: $name, expression: "iLIKE" }
                        { left: "first_name", right: $name, expression: "iLIKE" }
                        { left: "last_name", right: $name, expression: "iLIKE" }
                        { left: "recipient", right: $recipient, expression: "iLIKE" }
                        { left: "order", right: $order, expression: "iLIKE" }
                    ]
                }
            ]
            orderBy: "customer_email"
            limit: $limit
            offset: $offset
        )
    }
`;

export const UPDATE_LAST_SENT = gql`
    mutation ($id: String!, $cwf_last_sent: MultiTypeInput!) {
        updateRow(
            table: "trnsx_ecom_activegc"
            id: $id
            values: [{ property: "cwf_last_sent", value: $cwf_last_sent }]
        )
    }
`;
